import { ReactNode } from "react";

/** Textos de las pantallas del accionista (`DatosAccionista`, `DomicilioAccionista` y `ConsultaBuro`). */
export interface AccionistaTextos {
  eyebrow: string;
  registro: {
    title: string;
    subtitle: ReactNode;
    /** Parte en negritas de la declaración bajo protesta. */
    declaracion: string;
  };
  domicilio: {
    title: string;
    subtitle: string;
  };
  /**
   * Título fijo de la validación para consulta de buró. Sin él, la pantalla lo arma con el tipo de la persona
   * ("Validación para consulta buró del accionista mayoritario").
   */
  buroTitle?: string;
}

const DEFAULT_TEXTOS: AccionistaTextos = {
  eyebrow: "Accionista mayoritario",
  registro: {
    title: "Registro del accionista mayoritario",
    subtitle: (
      <>
        Registra al socio con mayor participación en la empresa.
        <br />
        Si hay empate, elige a quien sea representante legal o tenga el puesto más alto. Si los socios son empresas o el
        mayoritario es extranjero, registra al representante legal.
      </>
    ),
    declaracion: "Declaro bajo protesta de decir verdad ser el accionista mayoritario",
  },
  domicilio: {
    title: "Domicilio del accionista",
    subtitle: "Ingresa el domicilio particular del accionista mayoritario.",
  },
};

/**
 * Por empresa (`getConfigName`). Solo cambian los textos; la pantalla y su lógica son las mismas. Flux registra al
 * accionista mayoritario o al representante legal (`S_AccionistaRegistro` con `__fluxFactoraje` en el diseño).
 */
const ACCIONISTA_POR_EMPRESA: Record<string, AccionistaTextos> = {
  flux: {
    eyebrow: "Accionista mayoritario o representante legal",
    registro: {
      title: "Registro del accionista mayoritario o representante legal",
      subtitle: (
        <>
          Registra al socio con mayor participación en la empresa o a quien tenga poderes para obligarla y firmar el
          contrato.
          <br />
          Él autorizará la consulta de buró.
        </>
      ),
      declaracion: "Declaro bajo protesta de decir verdad ser el accionista mayoritario o el representante legal",
    },
    domicilio: {
      title: "Domicilio del accionista o representante legal",
      subtitle: "Ingresa el domicilio particular del accionista mayoritario o representante legal.",
    },
    buroTitle: "Validación para consulta buró del accionista mayoritario o representante legal",
  },
};

export const getAccionistaTextos = (configName: string) => ACCIONISTA_POR_EMPRESA[configName] ?? DEFAULT_TEXTOS;
